import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { HomePage } from '@/pages/HomePage';
import { MainLayout } from '@/components/Layout/MainLayout';

const SignalPage = lazy(() => import('@/pages/SignalPage'));
const AMPage = lazy(() => import('@/pages/AMPage'));
const FMPage = lazy(() => import('@/pages/FMPage'));
const PMPage = lazy(() => import('@/pages/PMPage'));
const AboutPage = lazy(() => import('@/pages/AboutPage'));
const LearnPage = lazy(() => import('@/pages/LearnPage'));
const GlossaryPage = lazy(() => import('@/pages/GlossaryPage'));
const ResourcesPage = lazy(() => import('@/pages/ResourcesPage'));
const YUVPage = lazy(() => import('@/pages/YUVPage'));
const AMRandomPage = lazy(() => import('@/pages/AMRandomPage'));
const ComparePage = lazy(() => import('@/pages/ComparePage'));
const SoundEncodingPage = lazy(() => import('@/pages/SoundEncodingPage'));

function App() {
  return (
    <Router>
      <MainLayout>
        <Suspense fallback={<div className="p-4 text-center">Загрузка страницы...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/signal" element={<SignalPage />} />
            <Route path="/am" element={<AMPage />} />
            <Route path="/fm" element={<FMPage />} />
            <Route path="/pm" element={<PMPage />} />
            <Route path="/learn" element={<LearnPage />} />
            <Route path="/glossary" element={<GlossaryPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/yuv" element={<YUVPage />} />
            <Route path="/am-random" element={<AMRandomPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/sound-encoding" element={<SoundEncodingPage />} />
          </Routes>
        </Suspense>
      </MainLayout>
    </Router>
  );
}

export default App;